import { FC } from 'react'
import { ProductPageLayout } from '~/components/ProductPageLayout/ProductPageLayout'
import { ProductPage } from '~/components/ProductPage/WardrobeProductPage'
import { WardrobeProductConfigurator } from '~/components/ProductPage/productTypes/wardrobe'
import { OpeningType } from '~/components/ThreeDModel/furnitureConfig'

export const preview = {
  name: 'products.wardrobe.4.name',
  link: '/product/wardrobe/4',
  // src: '/wardrobe/Light Grey/push/Base 20/H2400/right/2500-5.png',
  src: '/cdn/ready-products/wardrobe/2500-5_2.png',
  dimensions: '240x260x50',
  color: 'Light Grey',
  price: 16990,
}

const Product: FC = () => {
  return (
    <ProductPageLayout>
      <ProductPage
        components={WardrobeProductConfigurator}
        name={preview.name}
        values={{
          imageCarousel: ['/cdn/ready-products/wardrobe/2500-5_2.png'],
          colors: preview.color,
          dimensions: {
            width: 240,
            height: 260,
            depth: 50,
            plintHeight: 2,
          },
          furniture: {
            openingType: OpeningType.Push,
            guides: 'homepage.configurator.fittings.guides.options.1',
          },
          sections: {
            number: 3,
            mirror: 'nu',
            arrangement: [
              {
                src: '/cdn/wardrobe/filling/Light Grey/2100/1.png',
                width: 96,
                height: 224,
              },
              {
                src: '/cdn/wardrobe/filling/Light Grey/2100/2.png',
                width: 96,
                height: 224,
              },
              {
                src: '/cdn/wardrobe/filling/Light Grey/2100/4.png',
                width: 48,
                height: 224,
              },
            ],
            opening: [
              {
                src: '/cdn/wardrobe/opening-double.png',
                width: 96,
                height: 254,
              },
              {
                src: '/cdn/wardrobe/opening-double.png',
                width: 96,
                height: 254,
              },
              {
                src: '/cdn/wardrobe/opening-right.png',
                width: 48,
                height: 254,
              },
            ],
          },
          price: preview.price,
        }}
      />
    </ProductPageLayout>
  )
}

export default Product
